import {
  DayOfWeek,
  AddReason,
  CancelReason,
  OverrideType,
  DayStatus,
  TimeSource,
} from './types'

// ── Day of Week Labels ──

export const DAY_OF_WEEK_LABELS: Record<DayOfWeek, string> = {
  [DayOfWeek.Monday]: 'Mon',
  [DayOfWeek.Tuesday]: 'Tue',
  [DayOfWeek.Wednesday]: 'Wed',
  [DayOfWeek.Thursday]: 'Thu',
  [DayOfWeek.Friday]: 'Fri',
  [DayOfWeek.Saturday]: 'Sat',
  [DayOfWeek.Sunday]: 'Sun',
}

export const DAY_OF_WEEK_FULL_LABELS: Record<DayOfWeek, string> = {
  [DayOfWeek.Monday]: 'Monday',
  [DayOfWeek.Tuesday]: 'Tuesday',
  [DayOfWeek.Wednesday]: 'Wednesday',
  [DayOfWeek.Thursday]: 'Thursday',
  [DayOfWeek.Friday]: 'Friday',
  [DayOfWeek.Saturday]: 'Saturday',
  [DayOfWeek.Sunday]: 'Sunday',
}

// ── Calendar Day Colors ──

export const DAY_STATUS_COLORS: Record<DayStatus, string> = {
  service: '#E8F5E9', // green
  'ad-hoc-on': '#E3F2FD', // blue
  cancelled: '#FFEBEE', // red
  'no-schedule': '#FFFFFF', // white
}

export const DAY_STATUS_BORDER_COLORS: Record<DayStatus, string> = {
  service: '#81C784',
  'ad-hoc-on': '#64B5F6',
  cancelled: '#E57373',
  'no-schedule': '#E0E0E0',
}

export const WEEKEND_BG = '#F5F5F5'

// ── Time Source Colors (text color for cutoff/dropoff labels) ──

export const TIME_SOURCE_COLORS: Record<TimeSource, string> = {
  global: '#9E9E9E', // light gray — global default from scheduleSettings
  schedule: '#757575', // darker gray — schedule-level default
  rule: '#1565C0', // dark blue — per-rule
  override: '#E65100', // orange — per-date
}

// ── Emoji Prefixes ──

export const CUTOFF_EMOJI = '\u2702\uFE0F' // ✂️
export const DROPOFF_EMOJI = '\uD83C\uDF7D\uFE0F' // 🍽️

// ── Override Type Labels ──

export const OVERRIDE_TYPE_LABELS: Record<OverrideType, string> = {
  [OverrideType.Add]: 'Day On',
  [OverrideType.Cancel]: 'Day Off',
  [OverrideType.Modify]: 'Modify',
}

// ── Reason Labels ──

export const CANCEL_REASON_LABELS: Record<CancelReason, string> = {
  [CancelReason.OfficeClosure_Planned]: 'Office Closure (Planned)',
  [CancelReason.OfficeClosure_Unplanned]: 'Office Closure (Unplanned)',
  [CancelReason.LowAttendance]: 'Low Attendance / WFH Trends',
  [CancelReason.EventBasedChange]: 'Event-Based Change',
  [CancelReason.ServiceRelatedPause]: 'Service Related Pause',
  [CancelReason.ReasonUnknown]: 'Reason Unknown',
}

export const ADD_REASON_LABELS: Record<AddReason, string> = {
  [AddReason.MakeupDay]: 'Makeup Day',
  [AddReason.SpecialEvent]: 'Special Event',
  [AddReason.ExecutiveOrVIPVisit]: 'Executive / VIP Visit',
  [AddReason.SeasonalOrHolidayCelebration]: 'Seasonal / Holiday Celebration',
  [AddReason.ReasonUnknown]: 'Reason Unknown',
}

// ── Cycle Length Options ──

export const CYCLE_LENGTH_OPTIONS = [
  { value: '', label: 'Ad Hoc Only (no recurring)' },
  { value: '1', label: '1 Week' },
  { value: '2', label: '2 Weeks (Biweekly)' },
  { value: '3', label: '3 Weeks' },
  { value: '4', label: '4 Weeks (Monthly)' },
]

// ── Month Labels ──

export const MONTH_LABELS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]
